export default "__VITE_ASSET__lCm5SAF5__"